import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import TableBodyCheckbox from '../../../../components/Table/BodyCheck';

import { useTbodyPosition } from '../../../../utils/hooks/useTbodyPosition';

const TableBody = ({ isLoading, tickets, values, config, onChangeCheck }) => {
  const bodyRef = useRef(null);
  const position = useTbodyPosition({ bodyRef, count: tickets?.length, bodyHeight: '300px' });
  const availableLevel = !!config?.user_levels;

  return (
    <tbody
      className={classNames('', { 'tbody-loading': isLoading })}
      style={{ backgroundPositionY: position.y, backgroundPositionX: position.x }}
      ref={bodyRef}
    >
      {tickets?.map((item, index) => (
        <tr key={index} className={values.includes(item.id) ? 'active' : ''}>
          {config?.mass_actions
            ? (
              <TableBodyCheckbox
                item={item}
                disabled={item.status === 4}
                values={values}
                onChangeCheck={onChangeCheck}
              />
            ) : null}
          <td className="p-l">
            {item.id}
          </td>
          <td>
            {item.login}
          </td>
          {availableLevel && <td>{item?.user_level?.title || ''}</td>}
          <td className="tickets__subject">
            {config?.view_ticket ? (
              <Link to={`/tickets/view?id=${item.id}`} className={item.unread ? 'tickets__unread' : ''}>
                {item.subject}
              </Link>
            ) : (
              <span className={item.unread ? 'tickets__unread' : ''}>{item.subject}</span>
            )}
          </td>
          <td>
            {item.status_name}
            {item.locked && <i className="fas fa-lock status-icon" />}
          </td>
          <td className="p-l">
            {config.assignment ? item.assignee : null}
          </td>
          <td>
            {item.created}
          </td>
          <td>
            {item.updated}
          </td>
        </tr>
      ))}
    </tbody>
  );
};

TableBody.propTypes = {
  isLoading: PropTypes.bool,
  tickets: PropTypes.array,
  values: PropTypes.array,
  config: PropTypes.object,
  onChangeCheck: PropTypes.func,
};

export default TableBody;
